






































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import SettingModule from '@/store/modules/Setting';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class PasswordView extends Mixins(ErrorHandleMixin) {
  SettingInstance = getModule(SettingModule, this.$store);

  data = {
    logo: {
      favicon: 'https://ambslot.com/images/ambslot_logo.png',
      logo_small: 'https://ambslot.com/images/ambslot_logo.png',
      logo_meduim: 'https://ambslot.com/images/ambslot_logo.png',
      logo_large: 'https://ambslot.com/images/ambslot_logo.png',
      poweredBy: 'https://ambslot.com/images/ambslot_logo.png',
    },
    theme: 1,
  }

  // async mounted() {
  //   const data = await this.SettingInstance.GetData();
  //   this.data = data;
  // }

  async submit() {
    const res = await this.SettingInstance.EditSetting(this.data);
    this.checkError(res.status);
  }
}
